/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_IdpSessionResponse_ } from '../models/PaginatedResponse_IdpSessionResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IdpSessionsService {
    /**
     * Get current user's active IDP sessions
     * Get all active IDP sessions for the current user
     * @param skip
     * @param limit
     * @param userSession
     * @returns PaginatedResponse_IdpSessionResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyActiveSessions(
        skip?: number,
        limit: number = 100,
        userSession?: (string | null),
    ): CancelablePromise<PaginatedResponse_IdpSessionResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/idp-sessions/me/active',
            cookies: {
                'user_session': userSession,
            },
            query: {
                'skip': skip,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Sign out from a specific IDP session
     * Sign out the current user from a specific IDP session
     * @param sessionId The IDP session ID to sign out
     * @param userSession
     * @returns void
     * @throws ApiError
     */
    public static signOutSession(
        sessionId: string,
        userSession?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/idp-sessions/me/{session_id}',
            path: {
                'session_id': sessionId,
            },
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Sign out current user from all other sessions
     * Sign out the current user from all active sessions except the current one
     * @param userSession
     * @returns void
     * @throws ApiError
     */
    public static signoutCurrentUserFromAllOtherSessions(
        userSession?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/idp-sessions/me/signout-all-other-sessions',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
